import { UserEditPage } from "~/domain/common";
import { DsmNavigation } from "../../DsmNavigation";

export function DsmUserEditPage() {
  return <UserEditPage navigation={<DsmNavigation />} />;
}
